import { ComponentProps, ReactNode } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  children: ReactNode
  title?: string
  subtitle?: string
  styles?: ComponentProps<typeof Box>
}

const SummaryBox = ({ children, title, subtitle, styles }: Props) => {
  return (
    <Box gap="s6" paddingY="s16" flexGrow flexDirection="column" {...styles}>
      {title && (
        <Text.Normal color="grey800" weight="medium" size="200">
          {title}
        </Text.Normal>
      )}

      {subtitle && (
        <Text.Normal color="grey800" size="100">
          {subtitle}
        </Text.Normal>
      )}

      {children}
    </Box>
  )
}

export default observer(SummaryBox)
